import { Reducer } from "redux";

import { CLEAR_SESSION, SET_IS_AUTH_LOADING, SET_SESSION } from "./types";
import { SessionStore } from "../../../types/ReduxTypes/StoreTypes";

const initialState: SessionStore = {
  isAuthenticated: false,
  session: null,
  isLoading: false,
};

const sessionReducer: Reducer<SessionStore> = (
  state = initialState,
  // eslint-disable-next-line no-shadow
  action,
) => {
  switch (action.type) {
    case SET_IS_AUTH_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_SESSION:
      return { ...state, isAuthenticated: true, session: action.payload };
    case CLEAR_SESSION:
      return { ...initialState, isAuthenticated: false, session: null };
    default:
      return state;
  }
};

export default sessionReducer;
